/* eslint-disable no-console */
<template>
  <div class="hello">
    <section v-if="!loggedIn" class="hero is-fullheight">
      <div class="hero-body yellowBG">
        <div class="container columns is-vcentered has-text-centered">
          <div class="column is-6">
            <!-- <img src="../assets/i3iot2.png" alt=""> -->
            <h3 class="title is-size-2 has-text-dark">Sense Smart</h3>
            <h4 class="subtitle is-size-4 has-text-dark">
              Water Quality Check <br />Real-time Dashboard
            </h4>
            <h4 class="subtitle is-size-4 has-text-dark"></h4>
          </div>
          <div class="column is-4 is-offset-1">
            <h3 class="title has-text-dark">Login</h3>
            <p class="subtitle has-text-dark" style="font-weight:normal;">
              Please login to proceed.
            </p>
            <div class="box">
              <!-- <figure class="avatar">
                                        <img src="https://placehold.it/128x128">
              </figure>-->
              <!-- <form> -->
              <div class="field">
                <div class="control">
                  <input
                    class="input is-large"
                    @input="clearError"
                    type="text"
                    v-model="uname"
                    placeholder="Your Username"
                    autofocus
                  />
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <input
                    class="input is-large"
                    @input="clearError"
                    type="password"
                    v-model="pass"
                    placeholder="Your Password"
                  />
                </div>
              </div>
              <!-- <div class="field">
                                            <label class="checkbox">
                                                <input type="checkbox">
                                                Remember me
                                            </label>
              </div>-->
              <button
                class="button is-block is-dark greyBG is-large is-fullwidth"
                @click="login"
              >
                Login
              </button>
              <p v-if="errorCode in errors" class="subtitle has-text-danger">
                {{ errors[errorCode] }}
              </p>
              <!-- </form> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-else>
      <nav class="navbar is-dark">
        <div class="container">
          <div class="navbar-brand">
            <div class="navbar-item is-size-6">Sense Smart</div>
            <div
              @click="toggleMenu"
              role="button"
              :class="[showMenu ? 'is-active' : '', 'navbar-burger']"
              aria-label="menu"
              aria-expanded="false"
              data-target="navMenu"
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div
            id="navMenu"
            :class="[showMenu ? 'is-active' : '', 'navbar-menu']"
          >
            <div class="navbar-start">
              <a
                @click="
                  menu = 'zone';
                  showMenu = false;
                "
                class="navbar-item brand-text"
              >
                <span class="icon">
                  <i class="fas fa-chart-bar"></i>
                </span>
                <span>Zone</span>
              </a>
              <a
                @click="
                  menu = 'events';
                  showMenu = false;
                "
                class="navbar-item brand-text"
              >
                <span class="icon">
                  <i class="fas fa-calendar"></i>
                </span>
                <span>Events</span>
              </a>
              <a
                @click="
                  menu = 'logs';
                  showMenu = false;
                "
                class="navbar-item brand-text"
              >
                <span class="icon">
                  <i class="fas fa-download"></i>
                </span>
                <span>Export Logs</span>
              </a>
              <a
                target="_blank"
                href="https://analytics.amplitude.com/SenseSmart/dashboard/dev9zla/tv"
                class="navbar-item brand-text"
              >
                <span class="icon">
                  <i class="fas fa-chart-bar"></i>
                </span>
                <span>Analytics</span>
              </a>
            </div>
            <div class="navbar-end">
              <a class="navbar-item brand-text" @click="logOut">
                <span>Log out</span>
                <span class="icon">
                  <i class="fas fa-sign-out-alt"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <div class="header-center">
        <i class="fas has-text-info fa-tint"></i> Water Quality Monitoring
        Dashboard
      </div>
      <div class="container" v-if="menu == 'dashboard'">
        <devices
          :deviceID="currentID"
          @updateMenu="updateMenu"
          :deviceMap="deviceMap"
          :devices="devices"
        ></devices>
      </div>

      <!-- events -->
      <div class="container" v-else-if="menu == 'events'">
        <events :events="events"></events>
      </div>

      <!-- events -->
      <div class="container" v-else-if="menu == 'logs'">
        <logs></logs>
      </div>

      <!-- zone -->
      <div class="container" v-else-if="menu == 'zone'">
        <zone @updateMenu="updateMenu" :devices="devices"></zone>
      </div>
    </div>
  </div>
</template>

<script>
import Events from "./Events";
import Logs from "./Logs";
import Devices from "./Devices";
import Zone from "./Zone";
var trim = require("lodash.trim");
import mqtt from "mqtt";
const url = "wss://api.sensesmart.in:8084/mqtt";
import { deviceMap } from "./utility";
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  components: {
    events: Events,
    logs: Logs,
    devices: Devices,
    zone: Zone
  },
  data() {
    return {
      deviceStatus: false,
      uname: "",
      pass: "",
      errorCode: 0,
      loggedIn: false,
      devices: {},
      deviceMap: deviceMap,
      deviceMapDetail: {
        TM: "Temperature (Adc 6)",
        PH: "PH",
        TD: "TDS",
        AS: "Arsenic",
        DO: "Dissolved Oxygen",
        TU: "Turbidity",
        OR: "Oxidation Reduction Potential",
        HA: "Hardness",
        CO: "Conductivity"
      },
      errors: {
        500: "Incorrect Password, Please try again",
        501: "Please enter username",
        502: "Please enter password"
      },
      events: [],
      status: "OFFLINE",
      data: {},
      client: "",
      showMenu: true,
      currentID: 1,
      menu: "zone" //default menu
    };
  },
  mounted() {
    var vm = this;
    vm.uname = localStorage["uname"] || "";
    vm.pass = localStorage["pass"] || "";
    var loggedIn = localStorage["loggedin"] || "0";
    if (vm.uname !== "" && vm.pass !== "" && loggedIn === "1") {
      vm.login();
    }
    vm.init();
  },
  methods: {
    init() {
      let vm = this;
      for (let i = 1; i <= 10; i++) {
        let values = new Object({
          PH: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          TD: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          AS: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          DO: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          TU: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          OR: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          HA: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          CO: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          TM: {
            val: 50,
            min: 0,
            max: 0,
            avg: 50,
            count: 1
          },
          status: false
        });
        vm.$set(vm.devices, i, values);
      }
    },
    updateMenu(menu, i) {
      this.menu = menu;
      this.currentID = i;
    },
    toggleMenu() {
      var vm = this;
      vm.showMenu = !vm.showMenu;
    },
    simplifyDate(date) {
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },
    clearError() {
      var vm = this;
      vm.errorCode = 0;
    },
    logOut() {
      var vm = this;
      vm.client.end();
      vm.loggedIn = false;
      delete localStorage["uname"];
      delete localStorage["pass"];
      vm.uname = "";
      vm.pass = "";
    },
    login() {
      var vm = this;
      if (vm.uname === "") {
        vm.errorCode = 501;
        return;
      }
      if (vm.pass === "") {
        vm.errorCode = 502;
        return;
      }
      vm.client = mqtt.connect(url, {
        username: vm.uname,
        password: vm.pass,
        clean: true,
        clientId:
          "dashboard" +
          "-" +
          "sensesmart-" +
          "-" +
          Math.random()
            .toString(36)
            .substr(2, 3)
      });
      vm.client.on("error", function(err) {
        console.log(JSON.stringify(err));
        if (err.code === 4) {
          vm.errorCode = 500;
          console.log("Password error");
          vm.client.end();
        }
      });
      vm.client.on("connect", function() {
        console.log("Connected");
        vm.events = [];
        localStorage["uname"] = vm.uname;
        localStorage["pass"] = vm.pass;
        localStorage["loggedin"] = 1;
        vm.loggedIn = true;
        vm.showMenu = false;
      });
      vm.client.subscribe("t_1/c_1/z_1/#");

      vm.client.on("message", function(topic, payload) {
        // Examples:
        // console.log(topic)      // mqtt/demo
        // console.log(payload)    // Uint8Array(14) [104, 105, 32,104, 111, 119, 32, 97, 114, 101, 32, 121, 111, 117]
        console.log("Message Received:", [topic, payload].join(":")); // mqtt/demo:hi how are you
        topic = trim(topic, "/");
        var fields = topic.split("/");
        let device = fields[fields.length - 2].split("_")[1];
        console.log("TCL: login -> device", device);
        let sensor = fields[fields.length - 1];
        console.log("device", "sensor", device, sensor);
        if (device && sensor && sensor in vm.deviceMap) {
          console.log("inside");

          let value = parseFloat([payload].join(""));

          vm.$set(vm.devices[device][sensor], "val", value);
          if (
            value < vm.devices[device][sensor]["min"] ||
            vm.devices[device][sensor]["min"] === 0
          ) {
            vm.$set(vm.devices[device][sensor], "min", value);
          }
          if (vm.devices[device][sensor]["max"] < value) {
            vm.$set(vm.devices[device][sensor], "max", value);
          }
          let count = vm.devices[device][sensor]["count"];
          // console.log('count',count)
          vm.$set(vm.devices[device][sensor], "count", count + 1);
          // console.log('val',value)
          // console.log(vm.devices[device][sensor]['avg'])
          // console.log(count*value)
          // console.log(vm.devices[device][sensor]['avg']+count*value)
          let avg = (
            (count * vm.devices[device][sensor]["avg"] + value) /
            (count + 1)
          ).toFixed(2);
          // console.log('avg',avg)
          vm.$set(vm.devices[device][sensor], "avg", avg);
          // vm.data[fields[0]] = vm.dice(fields.slice(1),'payload')
          var event = [];
          event[0] = vm.deviceMapDetail[sensor];
          if ([payload].join("") === "status") {
            event[1] = 3;
          } else {
            event[1] = [payload].join("");
          }
          event[2] = new Date();
          vm.events.push(event);
        } else if (device && sensor && sensor === "status") {
          if ([payload].join("") === "OFF") {
            vm.$set(vm.devices[device], sensor, false);
          } else if ([payload].join("") === "ON") {
            vm.$set(vm.devices[device], sensor, true);
          }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
// .hero.is-success {
//   background: #F2F6FA;
// }

.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.box {
  margin-top: 5rem;
  border-radius: 0px;
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.05), 0 0 0 1px rgba(10, 10, 10, 0.05);
}

.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}

.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

input {
  font-weight: 300;
}

p {
  font-weight: 700;
}

p.subtitle {
  padding-top: 1rem;
}

nav.navbar {
  /* border-top: 4px solid #276cda; */
  margin-bottom: 1rem;
}

.navbar-item.brand-text {
  font-weight: 300;
}

.navbar-item,
.navbar-link {
  font-size: 14px;
  font-weight: 700;
}

.columns {
  width: 100%;
  height: 100%;
  margin-left: 0;
}

.menu-label {
  color: #8f99a3;
  letter-spacing: 1.3;
  font-weight: 700;
}

.menu-list a {
  color: #0f1d38;
  font-size: 14px;
  font-weight: 700;
}

.menu-list a:hover {
  background-color: transparent;
  color: #276cda;
}

.menu-list a.is-active {
  background-color: transparent;
  color: #276cda;
  font-weight: 700;
}

.card {
  /* box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18); */
  margin-bottom: 2rem;
}

.card-header-title {
  color: #8f99a3;
  font-weight: 400;
}

.card .content {
  font-size: 14px;
}

.card-footer-item {
  font-size: 14px;
  font-weight: 700;
  color: #8f99a3;
}

.card-table .table {
  margin-bottom: 0;
}
.header-center {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  color: #324851;
  margin: 10px;
}
</style>
